import React, {Component} from 'react';
import AssessmentPage from './AssessmentPage';
import GreenLeafApi from '../utils/GreenLeafApi';
import {Redirect} from 'react-router';
import ErrorComponent from '../ErrorComponent';

class CoachAssessment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      teamAssessment: null,
      team: {},
      error: [],
      answers: {},
      saved: false,
      isLoading: true,
      assessment: { id: 1, subsections: [] }
    };
  }

  async componentDidMount() {
    try {
      const team = (await GreenLeafApi.Team.get({teamId: this.props.match.params.teamId})).data[0];

      if (this.props.location.state && this.props.location.state.assessment) {
        this.setState({ assessment: this.props.location.state.assessment });
      } else {
        let answers = await GreenLeafApi.TeamAssessment.getLatestAssessmentAnswers(team.id);

        if (answers.data.assessment.length > 0) {
          answers = answers.data.assessment;
          const teamAssessment = await GreenLeafApi.TeamAssessment.get({ team_assessment_id: answers[0].team_assessment_id });
          this.inputPreviousAnswers(answers);
          this.setState({ teamAssessment: teamAssessment.data.teamAssessments[0] });
        }
      }

      this.setState({ team });
    } catch (e) {
      this.setState({ error: e.errors });
    }

    this.setState({ isLoading: false });
  }

  inputPreviousAnswers = (prevAnswers) => {
    let answers = prevAnswers.reduce((res, a) => {
      res[a.question_id] = {answer: a.answer_id, comment: a.question_comment};
      return res;
    }, {});
    this.setState({ answers });
  };

  onOptionSelect = async (question_id, answer_id) => {
    let teamAssessment = this.state.teamAssessment;
    if (!this.state.teamAssessment) {
      teamAssessment = await GreenLeafApi.TeamAssessment.create({ team_id: this.state.team.id, assessment_id: this.state.assessment.id, subsection_ids: this.state.assessment.subsections.map(s => s.id) });

      this.setState({ teamAssessment });
    }

    await this.updateAnswer(question_id, answer_id, (this.state.answers[question_id] || {}).comment || null);

    this.setState((prevState) => ({
      answers: {
        ...prevState.answers,
        [question_id]: { ...prevState.answers[question_id], answer: answer_id}
      }
    }));
  };

  onAssessmentUnmount = async (target) => {
    await this.updateAnswer(target.name, this.state.answers[target.name], target.value);
  };

  onChangeComment = async (questionId, comment) => {
    this.setState((prevState) => ({
      answers: {
        ...prevState.answers,
        [questionId]: { ...prevState.answers[questionId], comment}
      }
    }));
    
    let teamAssessment = this.state.teamAssessment;
    if (!teamAssessment) {
      teamAssessment = await GreenLeafApi.TeamAssessment.create({ team_id: this.state.team.id, assessment_id: this.state.assessment.id, subsection_ids: this.state.assessment.subsections.map(s => s.id) });
      this.setState({ teamAssessment });
    }

    await this.updateAnswer(questionId, this.state.answers[questionId].answer, comment, teamAssessment);
  };

  updateAnswer = async (question_id, answer_id, comment) => {
    const answer = { question_id, answer_id, comment };

    try {
      await GreenLeafApi.TeamAssessment.sendAnswer(answer, this.state.teamAssessment.id);
    } catch (e) {
      this.setState({ errors: e.errors });
    }
  };

  onSubmit = async () => {
    try {
      await GreenLeafApi.TeamAssessment.complete(this.state.teamAssessment.id);
      this.setState({ saved: true });
    } catch (e) {
      this.setState({ errors: e.errors });
    }
  };

  render() {
    if (this.state.isLoading) {
      return <p>Loading...</p>;
    }
    if (this.state.saved) {
      return <Redirect to={`/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}`}/>;
    }

    return (
      <div>
        <ErrorComponent error={this.state.errors}/>
        <AssessmentPage
          assessmentId={this.state.assessment.id}
          teamAssessment={this.state.teamAssessment}
          team={this.state.team}
          answers={this.state.answers}
          onOptionSelect={this.onOptionSelect}
          onUnmount={this.onAssessmentUnmount}
          onChangeComment={this.onChangeComment}
          onSubmit={this.onSubmit}
          teamAssessmentId={this.state.teamAssessment ? this.state.teamAssessment.id : null}
        />
      </div>
    );
  }
}

export default CoachAssessment;


// WEBPACK FOOTER //
// ./src/components/teams/CoachAssessment.js